
// import { useEffect, useMemo, useState } from "react";
// import "./PalaceVendorPages.css";

// const API =
//   process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com";

// const today = () => {
//   const d = new Date();
//   return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
// };

// async function api(url, options = {}) {
//   const token = localStorage.getItem("vendorToken");

//   const response = await fetch(`${API}${url}`, {
//     ...options,
//     headers: {
//       ...(options.body ? { "Content-Type": "application/json" } : {}),
//       ...(token ? { Authorization: `Bearer ${token}` } : {}),
//       ...options.headers,
//     },
//   });

//   const result = await response.json();

//   if (!response.ok || result.success === false) {
//     throw new Error(result.message || "Request failed");
//   }

//   return result;
// }

// const getList = (result) =>
//   Array.isArray(result) ? result : result?.data || [];

// const getId = (value) =>
//   typeof value === "string" ? value : value?._id || "";

// const initialForm = () => ({
//   date: today(),
//   totalRooms: "",
//   bookedRooms: "0",
//   blockedRooms: "0",
//   maintenanceRooms: "0",
//   stopSell: false,
//   closedToArrival: false,
//   closedToDeparture: false,
//   minimumStay: "1",
//   maximumStay: "30",
//   notes: "",
// });

// export default function PalaceInventory() {
//   const [palaces, setPalaces] = useState([]);
//   const [categories, setCategories] = useState([]);
//   const [records, setRecords] = useState([]);

//   const [palaceId, setPalaceId] = useState("");
//   const [roomCategoryId, setRoomCategoryId] = useState("");
//   const [startDate, setStartDate] = useState(today());
//   const [endDate, setEndDate] = useState(today());

//   const [form, setForm] = useState(initialForm());
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState("");
//   const [message, setMessage] = useState("");

//   useEffect(() => {
//     loadPalaces();
//   }, []);

//   useEffect(() => {
//     if (palaceId) loadCategories();
//   }, [palaceId]);

//   useEffect(() => {
//     if (palaceId) loadInventory();
//   }, [palaceId, roomCategoryId, startDate, endDate]);

//   async function loadPalaces() {
//     try {
//       const result = await api("/api/palaces");
//       const list = getList(result);

//       setPalaces(list);

//       if (list.length) {
//         setPalaceId(getId(list[0]));
//       }
//     } catch (err) {
//       setError(err.message);
//     }
//   }

//   async function loadCategories() {
//     try {
//       const result = await api(
//         `/api/palace-room-categories/palace/${palaceId}`
//       );

//       setCategories(getList(result));
//     } catch (err) {
//       setCategories([]);
//       setError(err.message);
//     }
//   }

//   async function loadInventory() {
//     setLoading(true);
//     setError("");

//     try {
//       const query = new URLSearchParams({
//         palaceId,
//         ...(roomCategoryId ? { roomCategoryId } : {}),
//         ...(startDate ? { startDate } : {}),
//         ...(endDate ? { endDate } : {}),
//       });

//       const result = await api(
//         `/api/palace-inventory?${query.toString()}`
//       );

//       setRecords(getList(result));
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   }

//   const change = (field, value) => {
//     setForm((old) => ({ ...old, [field]: value }));
//   };

//   const usedRooms =
//     Number(form.bookedRooms || 0) +
//     Number(form.blockedRooms || 0) +
//     Number(form.maintenanceRooms || 0);

//   const availableRooms = Math.max(
//     Number(form.totalRooms || 0) - usedRooms,
//     0
//   );

//   const stats = useMemo(
//     () =>
//       records.reduce(
//         (result, record) => ({
//           total: result.total + Number(record.totalRooms || 0),
//           booked: result.booked + Number(record.bookedRooms || 0),
//           available:
//             result.available + Number(record.availableRooms || 0),
//         }),
//         { total: 0, booked: 0, available: 0 }
//       ),
//     [records]
//   );

//   function editRecord(record) {
//     setForm({
//       date: String(record.date).slice(0, 10),
//       totalRooms: String(record.totalRooms ?? ""),
//       bookedRooms: String(record.bookedRooms ?? 0),
//       blockedRooms: String(record.blockedRooms ?? 0),
//       maintenanceRooms: String(record.maintenanceRooms ?? 0),
//       stopSell: Boolean(record.stopSell),
//       closedToArrival: Boolean(record.closedToArrival),
//       closedToDeparture: Boolean(record.closedToDeparture),
//       minimumStay: String(record.minimumStay ?? 1),
//       maximumStay: String(record.maximumStay ?? 30),
//       notes: record.notes || "",
//     });

//     setRoomCategoryId(getId(record.roomCategory));
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   }

//   async function saveInventory(event) {
//     event.preventDefault();
//     setError("");
//     setMessage("");

//     if (!palaceId || !roomCategoryId) {
//       setError("Palace aur room category select karo.");
//       return;
//     }

//     if (usedRooms > Number(form.totalRooms || 0)) {
//       setError(
//         "Booked, blocked aur maintenance rooms total rooms se zyada nahi ho sakte."
//       );
//       return;
//     }

//     if (Number(form.minimumStay) > Number(form.maximumStay)) {
//       setError("Minimum stay maximum stay se zyada nahi ho sakta.");
//       return;
//     }

//     setSaving(true);

//     try {
//       const payload = {
//         ...form,
//         palaceId,
//         roomCategoryId,
//         totalRooms: Number(form.totalRooms),
//         bookedRooms: Number(form.bookedRooms || 0),
//         blockedRooms: Number(form.blockedRooms || 0),
//         maintenanceRooms: Number(form.maintenanceRooms || 0),
//         minimumStay: Number(form.minimumStay || 1),
//         maximumStay: Number(form.maximumStay || 30),
//       };

//       const result = await api("/api/palace-inventory", {
//         method: "POST",
//         body: JSON.stringify(payload),
//       });

//       setMessage(result.message || "Inventory saved successfully.");
//       await loadInventory();
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setSaving(false);
//     }
//   }

//   async function deleteRecord(record) {
//     if (
//       !window.confirm(
//         `Delete inventory for ${String(record.date).slice(0, 10)}?`
//       )
//     ) {
//       return;
//     }

//     try {
//       const result = await api(
//         `/api/palace-inventory/${record._id}`,
//         { method: "DELETE" }
//       );

//       setMessage(result.message || "Inventory deleted.");
//       await loadInventory();
//     } catch (err) {
//       setError(err.message);
//     }
//   }

//   return (
//     <div className="pvp-page">
//       <div className="pvp-heading">
//         <div>
//           <span className="pvp-eyebrow">PALACE OPERATIONS</span>
//           <h1>Room Inventory</h1>
//           <p>Manage room availability and booking restrictions by date.</p>
//         </div>

//         <button
//           className="pvp-btn pvp-btn-light"
//           onClick={loadInventory}
//           disabled={!palaceId}
//         >
//           Refresh
//         </button>
//       </div>

//       <div className="pvp-stats">
//         <div><span>Total rooms</span><strong>{stats.total}</strong></div>
//         <div><span>Booked rooms</span><strong>{stats.booked}</strong></div>
//         <div><span>Available rooms</span><strong>{stats.available}</strong></div>
//         <div><span>Inventory records</span><strong>{records.length}</strong></div>
//       </div>

//       {error && <div className="pvp-alert pvp-error">{error}</div>}
//       {message && <div className="pvp-alert pvp-success">{message}</div>}

//       <section className="pvp-card">
//         <div className="pvp-card-title">
//           <div>
//             <h2>Set Daily Availability</h2>
//             <p>Set inventory for one room category and date.</p>
//           </div>
//         </div>

//         <form className="pvp-form-grid" onSubmit={saveInventory}>
//           <label>
//             Palace
//             <select
//               value={palaceId}
//               onChange={(e) => setPalaceId(e.target.value)}
//               required
//             >
//               <option value="">Select palace</option>
//               {palaces.map((p) => (
//                 <option key={p._id} value={p._id}>
//                   {p.propertyName || p.name || "Palace"}
//                 </option>
//               ))}
//             </select>
//           </label>

//           <label>
//             Room Category
//             <select
//               value={roomCategoryId}
//               onChange={(e) => setRoomCategoryId(e.target.value)}
//               required
//             >
//               <option value="">Select category</option>
//               {categories.map((c) => (
//                 <option key={c._id} value={c._id}>
//                   {c.name || c.roomType || "Room category"}
//                 </option>
//               ))}
//             </select>
//           </label>

//           <label>
//             Inventory Date
//             <input
//               type="date"
//               value={form.date}
//               onChange={(e) => change("date", e.target.value)}
//               required
//             />
//           </label>

//           <label>
//             Total Rooms
//             <input
//               type="number"
//               min="0"
//               value={form.totalRooms}
//               onChange={(e) => change("totalRooms", e.target.value)}
//               required
//             />
//           </label>

//           <label>
//             Booked Rooms
//             <input
//               type="number"
//               min="0"
//               value={form.bookedRooms}
//               onChange={(e) => change("bookedRooms", e.target.value)}
//             />
//           </label>

//           <label>
//             Blocked Rooms
//             <input
//               type="number"
//               min="0"
//               value={form.blockedRooms}
//               onChange={(e) => change("blockedRooms", e.target.value)}
//             />
//           </label>

//           <label>
//             Maintenance Rooms
//             <input
//               type="number"
//               min="0"
//               value={form.maintenanceRooms}
//               onChange={(e) =>
//                 change("maintenanceRooms", e.target.value)
//               }
//             />
//           </label>

//           <label>
//             Available Rooms
//             <div className="pvp-readonly">{availableRooms}</div>
//           </label>

//           <label>
//             Minimum Stay (Nights)
//             <input
//               type="number"
//               min="1"
//               value={form.minimumStay}
//               onChange={(e) => change("minimumStay", e.target.value)}
//             />
//           </label>

//           <label>
//             Maximum Stay (Nights)
//             <input
//               type="number"
//               min="1"
//               value={form.maximumStay}
//               onChange={(e) => change("maximumStay", e.target.value)}
//             />
//           </label>

//           <div className="pvp-span-2 pvp-checks">
//             <label>
//               <input
//                 type="checkbox"
//                 checked={form.stopSell}
//                 onChange={(e) => change("stopSell", e.target.checked)}
//               />
//               Stop Sell
//             </label>

//             <label>
//               <input
//                 type="checkbox"
//                 checked={form.closedToArrival}
//                 onChange={(e) =>
//                   change("closedToArrival", e.target.checked)
//                 }
//               />
//               Closed to Arrival
//             </label>

//             <label>
//               <input
//                 type="checkbox"
//                 checked={form.closedToDeparture}
//                 onChange={(e) =>
//                   change("closedToDeparture", e.target.checked)
//                 }
//               />
//               Closed to Departure
//             </label>
//           </div>

//           <label className="pvp-span-2">
//             Notes
//             <textarea
//               rows="2"
//               value={form.notes}
//               onChange={(e) => change("notes", e.target.value)}
//               placeholder="Optional notes"
//             />
//           </label>

//           <div className="pvp-form-actions pvp-span-2">
//             <button className="pvp-btn pvp-btn-primary" disabled={saving}>
//               {saving ? "Saving..." : "Save Inventory"}
//             </button>
//           </div>
//         </form>
//       </section>

//       <section className="pvp-card">
//         <div className="pvp-card-title">
//           <div>
//             <h2>Inventory Records</h2>
//             <p>Review or load existing daily inventory.</p>
//           </div>
//         </div>

//         <div className="pvp-toolbar pvp-toolbar-wrap">
//           <label>
//             From Date
//             <input
//               type="date"
//               value={startDate}
//               onChange={(e) => setStartDate(e.target.value)}
//             />
//           </label>

//           <label>
//             To Date
//             <input
//               type="date"
//               value={endDate}
//               onChange={(e) => setEndDate(e.target.value)}
//             />
//           </label>

//           <button
//             className="pvp-btn pvp-btn-light"
//             onClick={loadInventory}
//           >
//             Apply Filters
//           </button>
//         </div>

//         {loading ? (
//           <div className="pvp-empty">Loading inventory...</div>
//         ) : records.length === 0 ? (
//           <div className="pvp-empty">
//             <strong>No inventory records found</strong>
//             <span>Set your first date-wise inventory above.</span>
//           </div>
//         ) : (
//           <div className="pvp-table-wrap">
//             <table className="pvp-table">
//               <thead>
//                 <tr>
//                   <th>Date</th>
//                   <th>Category</th>
//                   <th>Total</th>
//                   <th>Booked</th>
//                   <th>Blocked</th>
//                   <th>Maintenance</th>
//                   <th>Available</th>
//                   <th>Restrictions</th>
//                   <th>Actions</th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {records.map((r) => (
//                   <tr key={r._id}>
//                     <td>{String(r.date).slice(0, 10)}</td>
//                     <td>
//                       {r.roomCategory?.name ||
//                         r.roomCategory?.roomType ||
//                         "—"}
//                     </td>
//                     <td>{r.totalRooms}</td>
//                     <td>{r.bookedRooms}</td>
//                     <td>{r.blockedRooms}</td>
//                     <td>{r.maintenanceRooms}</td>
//                     <td><strong>{r.availableRooms}</strong></td>
//                     <td>
//                       {[
//                         r.stopSell && "Stop sell",
//                         r.closedToArrival && "No arrival",
//                         r.closedToDeparture && "No departure",
//                       ].filter(Boolean).join(", ") ||
//                         `${r.minimumStay || 1}–${r.maximumStay || 30} nights`}
//                     </td>
//                     <td>
//                       <div className="pvp-row-actions">
//                         <button onClick={() => editRecord(r)}>
//                           Load to Form
//                         </button>
//                         <button
//                           className="pvp-danger-text"
//                           onClick={() => deleteRecord(r)}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         )}
//       </section>
//     </div>
//   );
// }

import { useEffect, useMemo, useState } from "react";

const API = process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com";

const today = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

async function api(url, options = {}) {
  const token = localStorage.getItem("vendorToken");

  const response = await fetch(`${API}${url}`, {
    ...options,
    headers: {
      ...(options.body ? { "Content-Type": "application/json" } : {}),
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  });

  const result = await response.json().catch(() => ({}));

  if (!response.ok || result.success === false) {
    throw new Error(result.message || "Request failed");
  }

  return result;
}

const getList = (result) => {
  if (Array.isArray(result)) return result;
  if (Array.isArray(result?.data)) return result.data;
  if (Array.isArray(result?.inventory)) return result.inventory;
  if (Array.isArray(result?.palaces)) return result.palaces;
  if (Array.isArray(result?.categories)) return result.categories;
  return [];
};

const getId = (value) =>
  typeof value === "string" ? value : value?._id || "";

const getPalaceName = (p) =>
  p?.propertyName ||
  p?.name ||
  p?.title ||
  p?.palaceName ||
  "Palace";

const getCategoryName = (category) =>
  category?.name || category?.title || category?.roomType || "Room Category";

const initialForm = () => ({
  date: today(),
  totalRooms: "",
  bookedRooms: "0",
  blockedRooms: "0",
  maintenanceRooms: "0",
  stopSell: false,
  closedToArrival: false,
  closedToDeparture: false,
  minimumStay: "1",
  maximumStay: "30",
  notes: "",
});

const inputClass =
  "mt-2 w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 outline-none transition placeholder:text-slate-400 focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100";

const labelClass = "block text-sm font-semibold text-slate-700";

function StatCard({ title, value, detail, icon, color }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition duration-200 hover:-translate-y-0.5 hover:shadow-md">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="text-sm font-medium text-slate-500">{title}</p>
          <p className="mt-3 text-3xl font-bold tracking-tight text-slate-900">
            {value}
          </p>
          <p className="mt-1 text-xs text-slate-500">{detail}</p>
        </div>
        <span
          className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl text-xl ${color}`}
        >
          {icon}
        </span>
      </div>
    </div>
  );
}

function ToggleCard({ title, description, checked, onChange }) {
  return (
    <label className="flex cursor-pointer items-start gap-3 rounded-xl border border-slate-200 bg-white p-4 transition hover:border-indigo-200 hover:bg-indigo-50/30">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1 h-4 w-4 accent-indigo-600"
      />
      <span>
        <span className="block text-sm font-semibold text-slate-800">
          {title}
        </span>
        <span className="mt-1 block text-xs leading-5 text-slate-500">
          {description}
        </span>
      </span>
    </label>
  );
}

function RestrictionBadge({ children }) {
  return (
    <span className="inline-flex rounded-full bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700 ring-1 ring-inset ring-amber-200">
      {children}
    </span>
  );
}

export default function PalaceInventory() {
  const [palaces, setPalaces] = useState([]);
  const [categories, setCategories] = useState([]);
  const [records, setRecords] = useState([]);

  const [palaceId, setPalaceId] = useState("");
  const [roomCategoryId, setRoomCategoryId] = useState("");
  const [startDate, setStartDate] = useState(today());
  const [endDate, setEndDate] = useState(today());
  const [search, setSearch] = useState("");

  const [form, setForm] = useState(initialForm());
  const [showForm, setShowForm] = useState(false);

  const [loadingPalaces, setLoadingPalaces] = useState(true);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    loadPalaces();
  }, []);

  useEffect(() => {
    if (!palaceId) {
      setCategories([]);
      setRecords([]);
      return;
    }

    loadCategories(palaceId);
  }, [palaceId]);

  useEffect(() => {
    if (palaceId) loadInventory();
  }, [palaceId, roomCategoryId, startDate, endDate]);

  async function loadPalaces() {
    setLoadingPalaces(true);

    try {
      const result = await api("/api/palaces");
      const list = getList(result);

      setPalaces(list);

      if (list.length) {
        setPalaceId((current) =>
          current && list.some((p) => getId(p) === current)
            ? current
            : getId(list[0])
        );
      } else {
        setPalaceId("");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoadingPalaces(false);
    }
  }

  async function loadCategories(id = palaceId) {
    if (!id) return;

    try {
      const result = await api(
        `/api/palace-room-categories/palace/${id}`
      );
      setCategories(getList(result));
    } catch (err) {
      setCategories([]);
      setError(err.message);
    }
  }

  async function loadInventory() {
    if (!palaceId) return;

    setLoading(true);

    try {
      const query = new URLSearchParams({ palaceId });

      if (roomCategoryId) query.set("roomCategoryId", roomCategoryId);
      if (startDate) query.set("startDate", startDate);
      if (endDate) query.set("endDate", endDate);

      const result = await api(
        `/api/palace-inventory?${query.toString()}`
      );

      setRecords(getList(result));
      setError("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  function change(field, value) {
    setForm((current) => ({ ...current, [field]: value }));
  }

  function openAddForm() {
    setForm({
      ...initialForm(),
      date: startDate || today(),
    });
    setError("");
    setMessage("");
    setShowForm(true);
  }

  function closeForm() {
    setShowForm(false);
    setForm(initialForm());
  }

  const usedRooms =
    Number(form.bookedRooms || 0) +
    Number(form.blockedRooms || 0) +
    Number(form.maintenanceRooms || 0);

  const availableRooms = Math.max(
    Number(form.totalRooms || 0) - usedRooms,
    0
  );

  const stats = useMemo(
    () =>
      records.reduce(
        (result, record) => ({
          total: result.total + Number(record.totalRooms || 0),
          booked: result.booked + Number(record.bookedRooms || 0),
          available:
            result.available +
            Number(
              record.availableRooms ??
                Math.max(
                  0,
                  Number(record.totalRooms || 0) -
                    Number(record.bookedRooms || 0) -
                    Number(record.blockedRooms || 0) -
                    Number(record.maintenanceRooms || 0)
                )
            ),
        }),
        { total: 0, booked: 0, available: 0 }
      ),
    [records]
  );

  const filteredRecords = useMemo(() => {
    const q = search.trim().toLowerCase();

    if (!q) return records;

    return records.filter((record) => {
      const category =
        getCategoryName(record.roomCategory).toLowerCase();

      return [
        String(record.date || "").slice(0, 10),
        category,
        record.totalRooms,
        record.bookedRooms,
        record.notes,
      ]
        .join(" ")
        .toLowerCase()
        .includes(q);
    });
  }, [records, search]);

  async function saveInventory(event) {
    event.preventDefault();
    setError("");
    setMessage("");

    if (!palaceId || !roomCategoryId) {
      setError("Please select a palace and room category.");
      return;
    }

    const total = Number(form.totalRooms);
    const booked = Number(form.bookedRooms || 0);
    const blocked = Number(form.blockedRooms || 0);
    const maintenance = Number(form.maintenanceRooms || 0);
    const minimum = Number(form.minimumStay || 1);
    const maximum = Number(form.maximumStay || 30);

    if (
      form.totalRooms === "" ||
      [total, booked, blocked, maintenance].some(
        (n) => !Number.isInteger(n) || n < 0
      )
    ) {
      setError("Enter valid whole numbers for room counts.");
      return;
    }

    if (booked + blocked + maintenance > total) {
      setError(
        "Booked, blocked and maintenance rooms cannot exceed total rooms."
      );
      return;
    }

    if (
      !Number.isInteger(minimum) ||
      !Number.isInteger(maximum) ||
      minimum < 1 ||
      maximum < minimum
    ) {
      setError("Please check the minimum and maximum stay values.");
      return;
    }

    setSaving(true);

    try {
      const payload = {
        ...form,
        palaceId,
        roomCategoryId,
        totalRooms: total,
        bookedRooms: booked,
        blockedRooms: blocked,
        maintenanceRooms: maintenance,
        minimumStay: minimum,
        maximumStay: maximum,
      };

      // Uses the original create endpoint.
      await api("/api/palace-inventory", {
        method: "POST",
        body: JSON.stringify(payload),
      });

      setMessage("Inventory saved successfully.");
      closeForm();
      await loadInventory();
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  }

  async function deleteRecord(record) {
    const dateLabel = String(record.date || "").slice(0, 10);

    if (
      !window.confirm(
        `Delete inventory for ${dateLabel}? This action cannot be undone.`
      )
    ) {
      return;
    }

    setError("");
    setMessage("");

    try {
      await api(`/api/palace-inventory/${record._id}`, {
        method: "DELETE",
      });

      setMessage("Inventory deleted successfully.");
      await loadInventory();
    } catch (err) {
      setError(err.message);
    }
  }

  function clearFilters() {
    setRoomCategoryId("");
    setStartDate("");
    setEndDate("");
    setSearch("");
  }

  return (
    <main className="min-h-screen bg-[#f5f7fb] p-4 sm:p-6 xl:p-8">
      <div className="mx-auto max-w-[1600px] space-y-6">

        {/* Header */}
        <header className="flex flex-col justify-between gap-5 lg:flex-row lg:items-center">
          <div>
            <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-indigo-600">
              <span className="h-2 w-2 rounded-full bg-indigo-600" />
              Palace Operations
            </div>

            <h1 className="mt-2 text-3xl font-bold tracking-tight text-slate-900">
              Room Inventory
            </h1>

            <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-500 sm:text-base">
              Monitor room availability, control daily inventory and manage
              booking restrictions from one place.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            <button
              type="button"
              onClick={loadInventory}
              disabled={!palaceId || loading}
              className="rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 shadow-sm transition hover:bg-slate-50 disabled:opacity-50"
            >
              {loading ? "Refreshing..." : "↻ Refresh"}
            </button>

            {!showForm && (
              <button
                type="button"
                onClick={openAddForm}
                disabled={!palaceId}
                className="inline-flex items-center gap-2 rounded-xl bg-indigo-600 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-4 focus:ring-indigo-100 disabled:cursor-not-allowed disabled:opacity-50"
              >
                <span className="text-xl leading-none">+</span>
                Add Inventory
              </button>
            )}
          </div>
        </header>

        {/* Alerts */}
        {error && (
          <div
            role="alert"
            className="flex items-start justify-between gap-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700"
          >
            <span>{error}</span>
            <button
              type="button"
              onClick={() => setError("")}
              className="font-bold"
            >
              ✕
            </button>
          </div>
        )}

        {message && (
          <div
            role="status"
            className="flex items-start justify-between gap-4 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700"
          >
            <span>{message}</span>
            <button
              type="button"
              onClick={() => setMessage("")}
              className="font-bold"
            >
              ✕
            </button>
          </div>
        )}

        {/* Filters */}
        <section className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
          <div className="mb-5 flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-indigo-50 text-lg">
              ⌕
            </span>
            <div>
              <h2 className="font-bold text-slate-900">Inventory Filters</h2>
              <p className="mt-1 text-xs text-slate-500">
                Choose a property, room category and date range.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
            <label className={labelClass}>
              Palace
              <select
                value={palaceId}
                disabled={loadingPalaces}
                onChange={(e) => {
                  setPalaceId(e.target.value);
                  setRoomCategoryId("");
                  setShowForm(false);
                  setError("");
                  setMessage("");
                }}
                className={inputClass}
              >
                <option value="">
                  {loadingPalaces ? "Loading palaces..." : "Select palace"}
                </option>

                {palaces.map((p) => (
                  <option key={p._id} value={getId(p)}>
                    {getPalaceName(p)}
                  </option>
                ))}
              </select>
            </label>

            <label className={labelClass}>
              Room Category
              <select
                value={roomCategoryId}
                onChange={(e) => setRoomCategoryId(e.target.value)}
                disabled={!palaceId}
                className={inputClass}
              >
                <option value="">All categories</option>

                {categories.map((c) => (
                  <option key={c._id} value={c._id}>
                    {getCategoryName(c)}
                  </option>
                ))}
              </select>
            </label>

            <label className={labelClass}>
              From Date
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className={inputClass}
              />
            </label>

            <label className={labelClass}>
              To Date
              <input
                type="date"
                min={startDate || undefined}
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className={inputClass}
              />
            </label>
          </div>

          <div className="mt-4 flex justify-end">
            <button
              type="button"
              onClick={clearFilters}
              className="rounded-lg px-3 py-2 text-sm font-semibold text-slate-500 transition hover:bg-slate-100 hover:text-slate-800"
            >
              Clear filters
            </button>
          </div>
        </section>

        {/* KPI cards */}
        <section className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
          <StatCard
            title="Total Room Capacity"
            value={stats.total}
            detail="Rooms across loaded records"
            icon="🏨"
            color="bg-indigo-50 text-indigo-600"
          />

          <StatCard
            title="Available Rooms"
            value={stats.available}
            detail="Current filtered inventory"
            icon="✓"
            color="bg-emerald-50 text-emerald-600"
          />

          <StatCard
            title="Booked Rooms"
            value={stats.booked}
            detail="Rooms already reserved"
            icon="▣"
            color="bg-blue-50 text-blue-600"
          />

          <StatCard
            title="Inventory Records"
            value={records.length}
            detail="Records in selected date range"
            icon="▤"
            color="bg-amber-50 text-amber-600"
          />
        </section>

        {/* Add inventory form: only opens on click */}
        {showForm && (
          <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
            <div className="flex flex-col justify-between gap-4 border-b border-slate-100 px-5 py-5 sm:flex-row sm:items-center sm:px-7">
              <div>
                <p className="text-xs font-bold uppercase tracking-wider text-indigo-600">
                  Inventory Setup
                </p>
                <h2 className="mt-1 text-xl font-bold text-slate-900">
                  Add Daily Inventory
                </h2>
                <p className="mt-1 text-sm text-slate-500">
                  Enter room counts and restrictions for the selected date.
                </p>
              </div>

              <button
                type="button"
                onClick={closeForm}
                className="self-start rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-600 transition hover:bg-slate-50 sm:self-auto"
              >
                Close form ✕
              </button>
            </div>

            <form onSubmit={saveInventory} className="space-y-8 p-5 sm:p-7">
              <div>
                <h3 className="mb-4 text-sm font-bold uppercase tracking-wider text-slate-500">
                  01 — Room & Date Details
                </h3>

                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
                  <label className={labelClass}>
                    Palace
                    <select
                      value={palaceId}
                      onChange={(e) => setPalaceId(e.target.value)}
                      required
                      className={inputClass}
                    >
                      <option value="">Select palace</option>
                      {palaces.map((p) => (
                        <option key={p._id} value={getId(p)}>
                          {getPalaceName(p)}
                        </option>
                      ))}
                    </select>
                  </label>

                  <label className={labelClass}>
                    Room Category *
                    <select
                      value={roomCategoryId}
                      onChange={(e) => setRoomCategoryId(e.target.value)}
                      required
                      className={inputClass}
                    >
                      <option value="">Select category</option>
                      {categories.map((c) => (
                        <option key={c._id} value={c._id}>
                          {getCategoryName(c)}
                        </option>
                      ))}
                    </select>
                  </label>

                  <label className={labelClass}>
                    Inventory Date *
                    <input
                      type="date"
                      value={form.date}
                      onChange={(e) => change("date", e.target.value)}
                      required
                      className={inputClass}
                    />
                  </label>
                </div>
              </div>

              <div>
                <h3 className="mb-4 text-sm font-bold uppercase tracking-wider text-slate-500">
                  02 — Room Availability
                </h3>

                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
                  <label className={labelClass}>
                    Total Rooms *
                    <input
                      type="number"
                      min="0"
                      step="1"
                      value={form.totalRooms}
                      onChange={(e) => change("totalRooms", e.target.value)}
                      required
                      placeholder="e.g. 40"
                      className={inputClass}
                    />
                  </label>

                  <label className={labelClass}>
                    Booked Rooms
                    <input
                      type="number"
                      min="0"
                      step="1"
                      value={form.bookedRooms}
                      onChange={(e) => change("bookedRooms", e.target.value)}
                      className={inputClass}
                    />
                  </label>

                  <label className={labelClass}>
                    Blocked Rooms
                    <input
                      type="number"
                      min="0"
                      step="1"
                      value={form.blockedRooms}
                      onChange={(e) => change("blockedRooms", e.target.value)}
                      className={inputClass}
                    />
                  </label>

                  <label className={labelClass}>
                    Maintenance Rooms
                    <input
                      type="number"
                      min="0"
                      step="1"
                      value={form.maintenanceRooms}
                      onChange={(e) =>
                        change("maintenanceRooms", e.target.value)
                      }
                      className={inputClass}
                    />
                  </label>
                </div>

                <div className="mt-5 flex flex-col justify-between gap-3 rounded-xl border border-emerald-200 bg-emerald-50 p-5 sm:flex-row sm:items-center">
                  <div>
                    <p className="text-sm font-semibold text-emerald-900">
                      Calculated Available Rooms
                    </p>
                    <p className="mt-1 text-xs text-emerald-700">
                      Total minus booked, blocked and maintenance rooms
                    </p>
                  </div>
                  <p className="text-3xl font-bold text-emerald-700">
                    {availableRooms}
                  </p>
                </div>
              </div>

              <div>
                <h3 className="mb-4 text-sm font-bold uppercase tracking-wider text-slate-500">
                  03 — Booking Restrictions
                </h3>

                <div className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
                  <ToggleCard
                    title="Stop Sell"
                    description="Stop selling this room category for the selected date."
                    checked={form.stopSell}
                    onChange={(value) => change("stopSell", value)}
                  />

                  <ToggleCard
                    title="Closed to Arrival"
                    description="Guests cannot check in on this date."
                    checked={form.closedToArrival}
                    onChange={(value) => change("closedToArrival", value)}
                  />

                  <ToggleCard
                    title="Closed to Departure"
                    description="Guests cannot check out on this date."
                    checked={form.closedToDeparture}
                    onChange={(value) => change("closedToDeparture", value)}
                  />
                </div>

                <div className="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2">
                  <label className={labelClass}>
                    Minimum Stay (Nights)
                    <input
                      type="number"
                      min="1"
                      step="1"
                      value={form.minimumStay}
                      onChange={(e) => change("minimumStay", e.target.value)}
                      required
                      className={inputClass}
                    />
                  </label>

                  <label className={labelClass}>
                    Maximum Stay (Nights)
                    <input
                      type="number"
                      min={form.minimumStay || 1}
                      step="1"
                      value={form.maximumStay}
                      onChange={(e) => change("maximumStay", e.target.value)}
                      required
                      className={inputClass}
                    />
                  </label>
                </div>
              </div>

              <div>
                <label className={labelClass}>
                  Internal Notes
                  <textarea
                    rows={3}
                    value={form.notes}
                    onChange={(e) => change("notes", e.target.value)}
                    placeholder="Add optional notes for your team..."
                    className={`${inputClass} resize-y`}
                  />
                </label>
              </div>

              <div className="flex flex-col-reverse gap-3 border-t border-slate-100 pt-5 sm:flex-row sm:justify-end">
                <button
                  type="button"
                  onClick={closeForm}
                  className="rounded-xl border border-slate-200 px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  disabled={saving || !categories.length}
                  className="rounded-xl bg-indigo-600 px-6 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-700 focus:outline-none focus:ring-4 focus:ring-indigo-100 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  {saving ? "Saving inventory..." : "Save Inventory"}
                </button>
              </div>
            </form>
          </section>
        )}

        {/* Records table */}
        <section className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm">
          <div className="flex flex-col justify-between gap-4 border-b border-slate-100 p-5 sm:flex-row sm:items-center sm:p-6">
            <div>
              <h2 className="text-lg font-bold text-slate-900">
                Inventory Records
              </h2>
              <p className="mt-1 text-sm text-slate-500">
                Review room availability and booking restrictions.
              </p>
            </div>

            <input
              type="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search records..."
              className="w-full rounded-xl border border-slate-200 px-4 py-3 text-sm outline-none transition focus:border-indigo-500 focus:ring-4 focus:ring-indigo-100 sm:max-w-sm"
            />
          </div>

          {!palaceId ? (
            <div className="p-12 text-center text-sm text-slate-500">
              Select a palace to view inventory records.
            </div>
          ) : loading ? (
            <div className="p-12 text-center text-sm text-slate-500">
              Loading inventory records...
            </div>
          ) : filteredRecords.length === 0 ? (
            <div className="px-5 py-16 text-center">
              <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-indigo-50 text-2xl">
                ▤
              </div>
              <h3 className="mt-4 font-bold text-slate-900">
                No inventory records found
              </h3>
              <p className="mt-1 text-sm text-slate-500">
                Try changing the filters or add your first inventory record.
              </p>
              {!showForm && (
                <button
                  type="button"
                  onClick={openAddForm}
                  className="mt-5 rounded-xl bg-indigo-600 px-5 py-3 text-sm font-semibold text-white transition hover:bg-indigo-700"
                >
                  + Add Inventory
                </button>
              )}
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table className="w-full min-w-[1150px] text-left text-sm">
                <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500">
                  <tr>
                    <th className="px-5 py-4 font-semibold">Date</th>
                    <th className="px-5 py-4 font-semibold">Room Category</th>
                    <th className="px-5 py-4 font-semibold">Total</th>
                    <th className="px-5 py-4 font-semibold">Booked</th>
                    <th className="px-5 py-4 font-semibold">Blocked</th>
                    <th className="px-5 py-4 font-semibold">Maintenance</th>
                    <th className="px-5 py-4 font-semibold">Available</th>
                    <th className="px-5 py-4 font-semibold">Restrictions</th>
                    <th className="px-5 py-4 text-right font-semibold">Actions</th>
                  </tr>
                </thead>

                <tbody className="divide-y divide-slate-100">
                  {filteredRecords.map((record) => {
                    const available = Math.max(
                      Number(record.availableRooms ??
                        Number(record.totalRooms || 0) -
                          Number(record.bookedRooms || 0) -
                          Number(record.blockedRooms || 0) -
                          Number(record.maintenanceRooms || 0)),
                      0
                    );

                    const restrictions = [
                      record.stopSell && "Stop Sell",
                      record.closedToArrival && "No Arrival",
                      record.closedToDeparture && "No Departure",
                    ].filter(Boolean);

                    return (
                      <tr
                        key={record._id}
                        className="transition hover:bg-slate-50"
                      >
                        <td className="whitespace-nowrap px-5 py-4 font-semibold text-slate-800">
                          {String(record.date || "").slice(0, 10)}
                        </td>

                        <td className="px-5 py-4 text-slate-600">
                          {getCategoryName(record.roomCategory)}
                        </td>

                        <td className="px-5 py-4 font-semibold text-slate-800">
                          {record.totalRooms ?? 0}
                        </td>

                        <td className="px-5 py-4 text-slate-600">
                          {record.bookedRooms ?? 0}
                        </td>

                        <td className="px-5 py-4 text-slate-600">
                          {record.blockedRooms ?? 0}
                        </td>

                        <td className="px-5 py-4 text-slate-600">
                          {record.maintenanceRooms ?? 0}
                        </td>

                        <td className="px-5 py-4">
                          <span className="font-bold text-emerald-700">
                            {available}
                          </span>
                        </td>

                        <td className="px-5 py-4">
                          <div className="flex max-w-64 flex-wrap gap-1.5">
                            {restrictions.length > 0 ? (
                              restrictions.map((item) => (
                                <RestrictionBadge key={item}>
                                  {item}
                                </RestrictionBadge>
                              ))
                            ) : (
                              <span className="text-xs text-slate-500">
                                {record.minimumStay || 1}–{record.maximumStay || 30} nights
                              </span>
                            )}
                          </div>
                        </td>

                        <td className="px-5 py-4">
                          <div className="flex justify-end">
                            <button
                              type="button"
                              onClick={() => deleteRecord(record)}
                              className="rounded-lg border border-red-200 px-3 py-2 text-xs font-semibold text-red-600 transition hover:bg-red-50"
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}

          <div className="flex flex-col justify-between gap-2 border-t border-slate-100 bg-slate-50/70 px-5 py-4 text-xs text-slate-500 sm:flex-row sm:items-center">
            <span>
              Showing {filteredRecords.length} of {records.length} records
            </span>
            <span>Inventory is displayed for the selected filters.</span>
          </div>
        </section>
      </div>
    </main>
  );
}
